import React from 'react'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button';

export default function HelpDonate() {
    return (
        <div>
            <div className='c_c'>
                <Image className='Tr_block_img' src='https://adonius.club/uploads/posts/2022-02/1644718545_5-adonius-club-p-izobrazhenie-fona-stranitsi-dlya-donationa-5.jpg'>
                </Image>

            </div>

            <div className='All_block_one'>
                <p className='All_text_block_one'>Поддержи сервера WorldGames, а так же наше сообщество</p>
            </div>

            <div className='HelpMinecraft_block'>
                <Button className='HelpMinecraft_button' href='https://www.donationalerts.com/r/worldggames' target='_blank' variant="dark">Поддержка</Button>
            </div>
            <div className='Tr_stick'></div>
        </div>
    )
}
